export const FIRST_TIME_OFFER_EMAIL_KEY = "highrays:first-time-offer-email";
export const FIRST_TIME_OFFER_NUDGE_DISMISSED_KEY =
	"highrays:first-time-offer-nudge-dismissed";
